import { FC } from 'react';

import { Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';
import { BOX_SHADOW } from 'src/constants';

interface SectionHeaderProps {
    title: string;
}

const SectionHeader: FC<SectionHeaderProps> = ({ title }) => {
    return (
        <Flex
            sx={{
                borderRadius: '16px 16px 0 0',
                overflow: 'hidden',
                boxShadow: BOX_SHADOW,
                marginBottom: '-8px', // To ensure the border is seamlessly connected to the table and hides rounded corners
            }}
        >
            <Flex
                sx={{
                    padding: '20px',
                    bgcolor: 'orange.main',
                    flex: 1,
                }}
            >
                <Typography variant="h4" color="white">
                    {title}
                </Typography>
            </Flex>
        </Flex>
    );
};

export default SectionHeader;
